// extracted by mini-css-extract-plugin
export default {"settings":"BrandGroupManager_settings__iRJ-W","colorUser":"BrandGroupManager_colorUser__SAPB3","footer":"BrandGroupManager_footer__fKJX9"};